module.exports = __webpack_public_path__ + "files/8a6d8ed89749165e1f09044215edb958.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Typewriter-Regular.woff2
// module id = 1114
// module chunks = 60